import {
  POST_SALES_APARTMENT,
  POST_SALES_CORPORATE,
  CAT_BY_PRODUCT,
  TAG,
  CONTRACT_APARTMENT,
  CONTRACT_CORPORATE,
  CONTRACT_SUPPLY,
  CLIENT_FOR_FINANCE,
  CAT_BY_BRAND
} from "./type";

const initalState = {
  postCorData: [],
  postApartmentData: [],
  getMaterial: [],
  getTag:[],
  contractAptData: [],
  contractCorpData: [],
  contractSupplyData: [],
  clients: [],
};

const contractCorporateReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case POST_SALES_CORPORATE:
      return {
        ...state,
        postCorData: payload,
      };
    case POST_SALES_APARTMENT:
      return {
        ...state,
        postApartmentData: payload,
      };
    case CAT_BY_PRODUCT:
      return {
        ...state,
        getMaterial: payload,
      };
    case CAT_BY_BRAND:
      return {
        ...state,
        getBrand: payload,
      };
    case TAG:
    return {
      ...state,
      getTag: payload,
    };
    case CONTRACT_APARTMENT:
      return {
        ...state,
        contractAptData: payload
      };
    case CONTRACT_CORPORATE:
      return {
        ...state,
        contractCorpData: payload
      };
    case CONTRACT_SUPPLY:
      return {
        ...state,
        contractSupplyData: payload
      };
    case CLIENT_FOR_FINANCE:
      return {
        ...state,
        clients: payload,
      };  
    default:
      return {
        ...state,
      };
  }
};

export default contractCorporateReducer;
